var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 439,
    viewBox: "0 0 356 439",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M344.333 240.176C344.333 344.343 271.417 396.426 184.75 426.634C180.212 428.172 175.282 428.099 170.792 426.426C83.9167 396.426 11 344.343 11 240.176V94.3427C11 88.8174 13.1949 83.5183 17.1019 79.6113C21.009 75.7043 26.308 73.5094 31.8333 73.5094C73.5 73.5094 125.583 48.5094 161.833 16.8427C166.247 13.0718 171.862 11 177.667 11C183.472 11 189.086 13.0718 193.5 16.8427C229.958 48.7177 281.833 73.5094 323.5 73.5094C329.025 73.5094 334.324 75.7043 338.231 79.6113C342.138 83.5183 344.333 88.8174 344.333 94.3427V240.176Z",
    stroke: "#C8D6C2",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.697a5bd00ac7f92ebbe537ede3e7ed83.svg";
export { ForwardRef as ReactComponent };